(function ($, document, window) {
    var options = {};

    // Controls
    var $requestCondition = $('.js-broking-request-condition');
    var $amountTotal = $('.js-broking-amount');

    function ValidateBrokingForm() {
        var isValid = true;
        var $validationList = $('#js-broking-validation-list');
        var $validationContainer = $('#js-broking-validation-container');

        $validationList.empty();

        if (!$('.js-broking-terms').is(':checked')) {
            isValid = false;
            $validationList.append('<li>Please confirm you have read the terms & conditions</li>');
        }

        if (options.ForceCondition && !RequestConditionSelected()) {
            isValid = false;
            $validationList.append('<li>A condition report is required for this wine</li>');
        }

        if (isValid) {
            $validationContainer.hide();
        } else {
            $validationContainer.show();
        }

        return isValid;
    }

    function DisplayPanel(panel) {
        var $loadingPanel = $('.js-broking-loading');
        var $brokingForm = $('.js-broking-form');
        var $successPanel = $('.js-broking-success');
        var $errorPanel = $('.js-broking-error');
        var $cancelPanel = $('.js-broking-cancel');

        switch (panel) {
            case 'Loading':
                $brokingForm.hide();
                $loadingPanel.show();
                $(document).scrollTop(0)
                break;
            case 'Success':
                $loadingPanel.hide();
                $successPanel.show();
                break;
            case 'Error':
                $loadingPanel.hide();
                $errorPanel.show();
                break;
            case 'Cancel':
                $brokingForm.hide();
                $cancelPanel.show();
        }
    }
    function SubmitBrokingForm() {
        if (!ValidateBrokingForm()) {
            return;
        }

        var $splitCase = $('.js-broking-split-case');

        var amount = $amountTotal.val();
        var data = $.parseJSON(options.BrokingFormData);
        data["amount"] = amount;
        data["splitCase"] = $splitCase.is(':checked');
        data["conditionReport"] = RequestConditionSelected();

        DisplayPanel('Loading');

        $.ajax({
            type: 'post',
            url: '/api/broking/add',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'text',
            onlySecure: true,
            success: function () {
                DisplayPanel('Success');
            },
            error: function () {
                DisplayPanel('Error');
            }
        });
    }

    function to2DecimalPlaces(num) {
        var num = parseFloat(Math.round(num * 100) / 100).toFixed(2);
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function roundUpTo2DecimalPlaces (num) {
        return Math.ceil(num * 100) / 100
    }

    function UpdatePriceBasedOnSlider() {
        var priceSetByCustomer = $('.js-broking-slider').attr('data-slider');
        var amountPerBottlePrice = priceSetByCustomer;

        if (options.IsDutyPaid) {
            priceSetByCustomer = priceSetByCustomer / 1.2;
        }
        $amountTotal.val(priceSetByCustomer);
        var totalPrice = priceSetByCustomer * options.BaseQuantity;
        var totalPriceWithVAT = amountPerBottlePrice * options.BaseQuantity;
        var totalProceeds = roundUpTo2DecimalPlaces(totalPrice - (totalPrice * options.TargetMarginPercent));

        $('.js-broking-text').hide();
        if (amountPerBottlePrice > options.CriticalAmount) {
            $('.js-broking-warning-text').show();
        }
        else {
            $('.js-broking-normal-text').show();
        }

        $('.js-broking-amount-per-bottle').html("£" + to2DecimalPlaces(amountPerBottlePrice) + " per bottle " + options.Duty);
        $('.js-broking-amount-total').html("£" + to2DecimalPlaces(totalPriceWithVAT) + " total");
        $('.js-broking-proceeds').html("£" + to2DecimalPlaces(totalProceeds) + " total");
    }

    function UpdateConditionReportDisplay(){
        if (RequestConditionSelected()) {
            $('.js-broking-proceeds-condition-report').show();
        } else {
            $('.js-broking-proceeds-condition-report').hide();
        }
    }

    function RequestConditionSelected() {
        if ($requestCondition.length == 0) return true;

        return $requestCondition.is(":checked");
    }

    window.LegacyInitializeBrokingSellYourWine = function (
        forceCondition,
        brokingFormData,
        baseQuantity,
        duty,
        targetMarginPercent,
        criticalAmount
    ) {
        options.ForceCondition = forceCondition;
        options.BrokingFormData = brokingFormData;
        options.BaseQuantity = baseQuantity;
        options.IsDutyPaid = duty === 'Duty paid';
        options.Duty = duty;
        options.TargetMarginPercent = targetMarginPercent;
        options.CriticalAmount = criticalAmount;

        $(document).on('click', '.js-broking-submit', function (e) {
            e.preventDefault();
            SubmitBrokingForm();
        }).on('click', '.js-broking-cancel', function (e) {
            e.preventDefault();
            DisplayPanel('Cancel');
        }).on('change.fndtn.slider', '[data-slider]', function () {
            UpdatePriceBasedOnSlider();
        }).on('change', $requestCondition, function (e) {
            e.preventDefault();
            UpdateConditionReportDisplay();
        });
    };

    window.InitializeBrokingSellYourWine = function (
        forceCondition,
        baseQuantity,
        duty,
        targetMarginPercent,
        criticalAmount
    ) {
        options.ForceCondition = forceCondition;
        options.BaseQuantity = baseQuantity;
        options.IsDutyPaid = duty === 'Duty paid';
        options.Duty = duty;
        options.TargetMarginPercent = targetMarginPercent;
        options.CriticalAmount = criticalAmount;

        $(document).on('change.fndtn.slider', '[data-slider]', function () {
            UpdatePriceBasedOnSlider();
        }).on('change', $requestCondition, function (e) {
            e.preventDefault();
            UpdateConditionReportDisplay();
        });
    };
})(jQuery, document, window);